import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { Router, Route, hashHistory } from 'react-router';
import App from './components';
import ConfirmPage from './components/confirmPage';
import FinishPage from './components/finishPage';
import Stores from './stores';

ReactDOM.render(
    <Provider stores={Stores}>
        <Router history={hashHistory}>
            <Route path="/" component={App} />
            <Route path="/step2" component={ConfirmPage} />
            <Route path="/step3" component={FinishPage} />
        </Router>
    </Provider>,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./mypage/js/MPS_CompanyInquiry/index.jsx